import { createFileRoute } from '@tanstack/react-router'

import { KitchenBoard } from '#components/features/orders/kitchen-board'

export const Route = createFileRoute('/_auth/_admin/pedidos')({
  head: () => ({
    meta: [{ title: 'Pedidos | UseComanda' }],
  }),
  component: RouteComponent,
})

function RouteComponent() {
  return <KitchenBoard />
}
